import React, { useContext, useMemo, useCallback } from "react";
import _ from "lodash";
// import styled, { useTheme } from "styled-components";
// import { Flex } from "reflexbox";
import { useQuery } from "../Hooks";
import { PageWrapper } from "../UI/Grid";
import { Body } from "../UI/Text";
import Table from "../UI/Table";
// import Button from "../UI/Button";
// import AlertContext from "../../context/alert/AlertContext";
import { getPlatforms } from "../../requests/platformManagementRequests";
import * as customerManagement from "../../requests/customerManagementRequests";
import { useNavigate, useParams } from "react-router-dom";
import UserContext from "../../context/user/UserContext";

const { getCustomers } = customerManagement;

// const ButtonsWrapper = styled(Flex)`
//   justify-content: center;
//   align-items: center;
//   transition: 200ms all ease-out;
// `;

const CustomersPage = () => {
  const navigate = useNavigate();
  // const theme = useTheme();
  // const { showSuccessAlert } = useContext(AlertContext);
  const { activeUser } = useContext(UserContext);
  const { pid } = useParams();

  const { data, isLoading, refetchQuery } = useQuery({
    queryID: "customers",
    request: getCustomers,
    queryVariables: { pid },
  });

  const { data: platformData, isLoading: platformsLoading } = useQuery({
    queryID: "platforms",
    request: getPlatforms,
    forcedFilters: {},
    skip: isLoading,
  });

  const { rows: platforms = [] } = platformData || {};

  const { count = 0, rows: customers = [] } = data || {};

  // const onDelete = useCallback(
  //   async (e, id) => {
  //     e.stopPropagation();
  //     const { rows } = data;
  //     const newRows = [...rows];
  //     _.remove(newRows, (row) => row.id === id);
  //     setData({ rows: newRows, count: count - 1 });
  //     await deleteCustomer({ id });

  //     showSuccessAlert(`Successfully deleted Contact with the ID of ${id}`);
  //   },
  //   [count, data, setData, showSuccessAlert]
  // );

  const onRowClick = useCallback(
    (row) => {
      navigate(`/Customer/${row.original.customer.id}`);
    },
    [navigate]
  );

  const columns = useMemo(() => {
    const cols = [
      {
        id: "erpId",
        data: (d) => {
          return (
            <Body center ellipsis>
              {d?.customer?.erpId || "—"}
            </Body>
          );
        },
        header: "ERP ID",
        size: { md: 1.15, sm: 1.15, xs: 1.15 },
      },
      {
        id: "companyName",
        data: (d) => <Body>{d?.customer?.companyName || "—"}</Body>,

        header: "Name",
        size: { md: 2, sm: 2, xs: 2 },
      },

      {
        id: "billingAddress",
        data: (d) => {
          const { billingAddress } = d || {};

          const { Address, Address2, City, State, Zip } = billingAddress || {};

          let label = "";

          if (Address) label += `${Address}`;
          if (Address2) {
            label += ` ${Address2}, `;
          }
          if (City) {
            label += `${City}`;
            if (State) {
              label += ` ${State}, `;
              if (Zip) {
                label += `${Zip}`;
              }
            }
          }

          return (
            <Body center ellipsis>
              {label || "—"}
            </Body>
          );
        },
        sort: false,
        header: "Billing Address",
        size: { lg: 6, md: 6, sm: 0, xs: 0 },
      },
      {
        id: "pid",
        data: (d) => (
          <Body center>
            {_.find(platforms, (p) => p.id === d?.customer?.pid)?.name || "—"}
          </Body>
        ),
        header: "Platform",
        size: { md: 2, sm: 0, xs: 0 },
      },
      // {
      //   display: (props) => {
      //     let customer = props.cell.row.original.customer;

      //     return (
      //       <ButtonsWrapper id="actions">
      //         <Button
      //           size="small"
      //           color={theme.secondary}
      //           reverse
      //           iconName="faPencil"
      //           onClick={(e) => onRowClick(props.cell.row, e)}
      //         />
      //         <Button
      //           size="small"
      //           color={theme.secondary}
      //           reverse
      //           iconName="faTrashCan"
      //           onClick={(e) => onDelete(e, customer.id)}
      //         />
      //       </ButtonsWrapper>
      //     );
      //   },
      //   header: "",
      //   sort: false,
      //   size: { lg: 2, md: 3, sm: 0, xs: 0 },
      // },
    ];

    if (activeUser?.roleLevel !== 9) _.remove(cols, ({ id }) => id === "pid");

    return cols;
  }, [platforms, activeUser]);

  return (
    <PageWrapper>
      <Table
        title="Customers"
        subtitle="Create new, and edit existing Customers. Customers that were created from a Quote will appear here. Only customers with an ERP ID set will be visible in the AutoFill Customer dropdown on Quote pages."
        data={customers}
        hideCreate
        createButtonText="Create Customer"
        createLink={() => navigate("/Customer/create")}
        createButtonIcon="faAddressCard"
        hideToggle
        hideRefetch={false}
        refetchData={refetchQuery}
        onRowClick={onRowClick}
        columns={columns}
        isLoading={isLoading || platformsLoading}
        totalCount={count}
        backButtonLink="/Administration"
      />
    </PageWrapper>
  );
};

export default CustomersPage;
